import { getCommonString } from '../../string-utils'

export const fileListItems = (
  groupedFileList,
  files,
  cameraProperties,
  lastSelected,
  metaData
) => {
  if (!groupedFileList || !files) {
    return null
  }
  const groupedFileListArray = Object.keys(groupedFileList)
    .map((groupKey, index) => {
      const features = groupedFileList[groupKey].map(id =>
        metaData.features.find(f => f.id === id)
      )

      const hasGeoRef = features.every(
        f => f.geometry || f.properties.calibration_picture
      )

      const fileList = groupedFileList[groupKey]
      const filenames = features.map(f => f.properties.filename)

      return {
        groupKey,
        fileList,
        hasGeoRef,
        isItemUploaded: fileList.every(
          fileId => files[fileId].uploadStatus === 'done'
        ),
        isMissingImagesInCapture:
          cameraProperties &&
          fileList.length < cameraProperties.imagesPerCapture,
        isMissingFilesInCapture: fileList.some(fileId => !files[fileId].file),
        isSelected: fileList.every(
          fileId => files[fileId] && files[fileId].isSelected
        ),
        name: getCommonString(filenames),
        currentSelected: lastSelected === groupKey,
      }
    })
    .sort((a, b) => {
      const same =
        a.hasGeoRef === b.hasGeoRef &&
        a.isMissingImagesInCapture === b.isMissingImagesInCapture &&
        a.isMissingFilesInCapture === b.isMissingFilesInCapture

      return same
        ? 0
        : !a.hasGeoRef ||
          a.isMissingFilesInCapture ||
          a.isMissingImagesInCapture
        ? -1
        : 1
    })

  return sortBadImages(groupedFileListArray)
}

export const sortBadImages = groupedFileListArray => {
  return groupedFileListArray.sort((a, b) => {
    const same =
      a.hasGeoRef === b.hasGeoRef &&
      a.isMissingImagesInCapture === b.isMissingImagesInCapture &&
      a.isMissingFilesInCapture === b.isMissingFilesInCapture

    const bothBad =
      (!a.hasGeoRef ||
        a.isMissingFilesInCapture ||
        a.isMissingImagesInCapture) &&
      (!b.hasGeoRef || b.isMissingFilesInCapture || b.isMissingImagesInCapture)

    return same || bothBad
      ? 0
      : !a.hasGeoRef || a.isMissingFilesInCapture || a.isMissingImagesInCapture
      ? -1
      : 1
  })
}
